import { useRouter } from 'next/router';

import { useBonusAmount } from 'hooks/useBonusAmount';

import setTrailingZeros from 'utils/setTrailingZeros';

type useP2PEnrollmentFlowApi = {
  activateP2pEnrollmentAndNavigate: (callback?: () => void) => void;
};

function useP2PEnrollmentFlow(
  isClaimWithChimeEnabled: boolean,
  amount?: string
): useP2PEnrollmentFlowApi {
  const { bonusAmount } = useBonusAmount();
  const router = useRouter();
  const {
    query: { token },
  } = router;

  const generateEnrollmentUrl = (): string => {
    const source = 'pay_anyone_v2';
    const ad = 'ch_pf';
    const idKey = 'ch_pfid';
    const baseUrl = `${process.env.CONSUMER_HOST}/enroll/account?ad=${ad}&${idKey}=${token}&pf_token=${token}&src=${source}`;

    let enrollmentQSPs = `&pf_p2p=true`;

    if (isClaimWithChimeEnabled)
      enrollmentQSPs = `${enrollmentQSPs}&pai_amount=${setTrailingZeros(
        amount || '0'
      )}&pai_bonus=${bonusAmount}`;

    return `${baseUrl}${enrollmentQSPs}`;
  };

  const activateP2pEnrollmentAndNavigate = (callback?: () => void) => {
    const enrollmentUrl = generateEnrollmentUrl();

    if (callback) {
      callback();
    }

    window.location.replace(enrollmentUrl);
  };

  return {
    activateP2pEnrollmentAndNavigate,
  };
}

export default useP2PEnrollmentFlow;
